import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-house-details-widget',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './house-details-widget.component.html',
    styleUrl: './house-details-widget.component.scss'
})
export class HouseDetailsWidgetComponent {}
